import * as PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import './index.css';
import successIcon from '../../../../assets/channelMigration/success.png';
import variables from '../../../../utils/variables';
import { connect } from 'react-redux';
import { Dialog, DialogContent } from '@material-ui/core';
import { ReactComponent as CancelIcon } from '../../../../assets/interactive/close.svg';
import { ReactComponent as InfoIcon } from '../../../../assets/infoIcon.svg';
import {
    hideChannelMigrationDialog,
    fetchChannelMigration,
    fetchChannelMigrationStatus,
    fetchChannelMigrationAuthzAccountAddress,
    fetchRetryChannelMigration,
} from '../../../../actions/channels/channelMigration';
import Lottie from 'lottie-react';
import BackgroundWavesAnimation from '../../../../assets/Abstract_waves_circles.json';
import SuccessGif from '../../../../assets/interactive/publish/success.gif';
import UserNameTextField from './UserNameTextField';
import DisplayNameTextField from './DisplayNameTextField';
import { appsLinks, config, DEFAULT_LIMIT, DEFAULT_SKIP, DEFAULT_TABLE_LIMIT } from '../../../../config';
import { GenericAuthorization } from 'cosmjs-types/cosmos/authz/v1beta1/authz';
import moment from 'moment/moment';
import {
    aminoSignTxProtoTX,
    fetchTxHash,
    protoBufSigning,
    setTxHashInProgressFalse,
    txSignAndBroadCast,
} from '../../../../actions/account/wallet';
import { showMessage } from '../../../../actions/snackbar';
import { fetchBalance } from '../../../../actions/account/BCDetails';
import { fetchGranterInfo } from '../../../../actions/interactiveVideos/videoDrops';
import withRouter from '../../../../components/WithRouter';
import CircularProgressBar from '../../../../components/CircularProgressBar';
import ErrorGif from '../../../../assets/channelMigration/error.gif';
import { getChannelMigrationStatusMessage } from '../../../../utils/strings';
import {
    fetchChannelAssets,
    fetchChannelContract,
    fetchChannelContractInfo,
    fetchChannelContractIV,
    fetchChannelVideosStats,
    setV2ChannelPresent,
} from '../../../../actions/channelContract';
import { fetchChannelInfo, fetchChannels } from '../../../../actions/channels';
import { ReactComponent as XIcon } from '../../../../assets/liveStream/x.svg';

const MigrationDialog = (props) => {
    const [migrationState, setMigrationState] = useState('');
    const [progress, setProgress] = useState(10);
    const msgTypes = [
        '/cosmwasm.wasm.v1.MsgExecuteContract',
        '/OmniFlix.marketplace.v1beta1.MsgDeListNFT',
        '/OmniFlix.marketplace.v1beta1.MsgCancelAuction',
    ];

    useEffect(() => {
        setMigrationState(props.migrationStage);
    }, [props.migrationStage]);

    useEffect(() => {
        if (migrationState === 'transfer') {
            const stages = props.channelMigrationStatus?.stages || {};
            let calculatedProgress = 0;

            if (stages.deleting_old_channel === 'COMPLETED') {
                calculatedProgress = 100;
            } else if (stages.deleting_old_channel === 'IN_PROGRESS') {
                calculatedProgress = 91;
            } else if (stages.live_stream_migration === 'COMPLETED') {
                calculatedProgress = 84;
            } else if (stages.live_stream_migration === 'IN_PROGRESS') {
                calculatedProgress = 77;
            } else if (stages.migrating_ivs === 'COMPLETED') {
                calculatedProgress = 70;
            } else if (stages.migrating_ivs === 'IN_PROGRESS') {
                calculatedProgress = 63;
            } else if (stages.publishing_assets === 'COMPLETED') {
                calculatedProgress = 56;
            } else if (stages.publishing_assets === 'IN_PROGRESS') {
                calculatedProgress = 49;
            } else if (stages.cancel_auction === 'COMPLETED') {
                calculatedProgress = 42;
            } else if (stages.cancel_auction === 'IN_PROGRESS') {
                calculatedProgress = 35;
            } else if (stages.delisting_nft === 'COMPLETED') {
                calculatedProgress = 28;
            } else if (stages.delisting_nft === 'IN_PROGRESS') {
                calculatedProgress = 21;
            } else if (stages.channel_migration === 'COMPLETED') {
                calculatedProgress = 14;
            } else if (stages.channel_migration === 'IN_PROGRESS') {
                calculatedProgress = 7;
            }

            setProgress(calculatedProgress);
        } else {
            let progress = 0;
            if (props.channelMigrationStatus?.position && props.channelMigrationStatus?.total_positions) {
                progress = Math.round(((props.channelMigrationStatus?.total_positions - props.channelMigrationStatus?.position + 1) / props.channelMigrationStatus?.total_positions) * 100);
            }

            setProgress(progress);
        }
    }, [migrationState, props.channelMigrationStatus]);

    useEffect(() => {
        if ((!props.channelMigrationAuthzAccountAddress || (typeof props.channelMigrationAuthzAccountAddress === 'object' &&
            Object.keys(props.channelMigrationAuthzAccountAddress).length === 0)) && !props.authzAccountAddressInProgress) {
            props.fetchChannelMigrationAuthzAccountAddress();
        }
    }, []);

    const handleGrantValidation = () => {
        props.fetchGranterInfo(props.address, (res) => {
            if (res && res.grants && res.grants.length) {
                const msg = msgTypes;
                let valid = false;
                res.grants.map((grant) => {
                    if (grant && grant.authorization && grant.authorization.msg && (grant.authorization.msg === msg) &&
                        (grant.grantee === props.channelMigrationAuthzAccountAddress?.account_address) &&
                        (grant.expiration) && (moment().diff(grant.expiration) < 0)) {
                        valid = true;
                    }
                });

                if (valid) {
                    handleMigration();
                } else {
                    handleAuth();
                }
            } else {
                handleAuth();
            }
        });
    };

    const handleAuth = () => {
        let balance = props.balance && props.balance.length && props.balance.find((val) => val.denom === config.COIN_MINIMAL_DENOM);
        balance = balance && balance.amount && balance.amount / (10 ** config.COIN_DECIMALS);

        const endTime = new Date();
        endTime.setDate(endTime.getDate() + 7);

        const msg = msgTypes.map((type) => ({
            typeUrl: '/cosmos.authz.v1beta1.MsgGrant',
            value: {
                granter: props.address,
                grantee: props.channelMigrationAuthzAccountAddress?.account_address,
                grant: {
                    authorization: {
                        typeUrl: '/cosmos.authz.v1beta1.GenericAuthorization',
                        value: new Uint8Array(GenericAuthorization.encode(
                            GenericAuthorization.fromPartial({
                                msg: type,
                            }),
                        ).finish()),
                    },
                    expiration: {
                        seconds: Math.floor(new Date(endTime).getTime() / 1000),
                    },
                },
            },
        }));

        const data = {
            msgs: msg,
            fee: {
                amount: [{
                    amount: String(225000),
                    denom: config.COIN_MINIMAL_DENOM,
                }],
                gasLimit: String(450000),
            },
            memo: '',
        };

        const type = '/cosmos.authz.v1beta1.MsgGrant';
        const granterInfo = {};
        if (props.allowances && props.allowances.length) {
            props.allowances.map((val) => {
                if (val && val.allowance && val.allowance.spend_limit && val.allowance.spend_limit.length) {
                    const amount = val.allowance.spend_limit.find((val1) => (val1.denom === config.COIN_MINIMAL_DENOM) &&
                        val1.amount && (val1.amount > 0.1 * (10 ** config.COIN_DECIMALS)));
                    if (amount && amount.amount) {
                        granterInfo.granter = val.granter;
                        granterInfo.amount = amount.amount / 10 ** config.COIN_DECIMALS;
                        granterInfo.expiration = val.allowance.expiration;
                    }
                } else if (val && val.allowance && val.allowance.allowed_messages &&
                    type && val.allowance.allowed_messages.indexOf(type) > -1) {
                    if (val && val.allowance && val.allowance.allowance &&
                        val.allowance.allowance.spend_limit && val.allowance.allowance.spend_limit.length) {
                        const amount = val.allowance.allowance.spend_limit.find((val1) => (val1.denom === config.COIN_MINIMAL_DENOM) &&
                            val1.amount && (val1.amount > 0.1 * (10 ** config.COIN_DECIMALS)));
                        if (amount && amount.amount) {
                            granterInfo.granter = val.granter;
                            granterInfo.amount = amount.amount / 10 ** config.COIN_DECIMALS;
                            granterInfo.expiration = val && val.allowance && val.allowance.allowance &&
                                val.allowance.allowance.expiration;
                        }
                    }
                }

                return null;
            });
        }

        if (((granterInfo && granterInfo.granter && !balance) ||
                (granterInfo && granterInfo.granter && balance && (balance < 0.1))) &&
            ((granterInfo && granterInfo.expiration) && moment().diff(granterInfo && granterInfo.expiration) < 0)) {
            data.fee.granter = granterInfo.granter;
        }

        if (props.keys && (props.keys.isNanoLedger || props.keys.isLedger)) {
            const msg = msgTypes.map((type) => ({
                typeUrl: '/cosmos.authz.v1beta1.MsgGrant',
                value: {
                    granter: props.address,
                    grantee: props.channelMigrationAuthzAccountAddress?.account_address,
                    grant: {
                        authorization: {
                            typeUrl: '/cosmos.authz.v1beta1.GenericAuthorization',
                            value: {
                                msg: type,
                            },
                        },
                        expiration: moment.utc(endTime).format(),
                    },
                },
            }));

            const data = {
                msgs: msg,
                fee: {
                    amount: [{
                        amount: String(5000),
                        denom: config.COIN_MINIMAL_DENOM,
                    }],
                    gas: String(500000),
                },
                memo: '',
            };

            props.aminoSignTx(data, props.address, (result) => {
                if (result && result.transactionHash) {
                    if (result && result.code !== undefined && result.code !== 0) {
                        props.showMessage(result.raw_log || result.logs, 'error', result && result.transactionHash);
                        props.setTxHashInProgressFalse();

                        return;
                    }

                    props.fetchBalance(props.address);
                    props.setTxHashInProgressFalse();
                    handleMigration();
                }
            });

            return;
        }

        props.sign(data, props.address, (result, txBytes) => {
            if (result) {
                const txData = {
                    tx_bytes: txBytes,
                    mode: 'BROADCAST_MODE_SYNC',
                };
                props.txSignAndBroadCast(txData, (res1) => {
                    handleHash(res1);
                });
            }
        });
    };

    const handleHash = (res1) => {
        if (res1 && res1.txhash) {
            let counter = 0;
            const time = setInterval(() => {
                props.fetchTxHash(res1.txhash, (hashResult) => {
                    if (hashResult) {
                        if (window.keplr) {
                            window.keplr.defaultOptions = {};
                        }

                        if (hashResult && hashResult.code !== undefined && hashResult.code !== 0) {
                            props.showMessage(hashResult.raw_log || hashResult.logs, 'error', hashResult && hashResult.hash);
                            props.setTxHashInProgressFalse();
                            clearInterval(time);

                            return;
                        }

                        props.fetchBalance(props.address);
                        props.setTxHashInProgressFalse();
                        handleMigration();
                        clearInterval(time);
                    }

                    counter++;
                    if (counter === 3) {
                        if (hashResult && hashResult.code !== undefined && hashResult.code !== 0) {
                            props.showMessage(hashResult.raw_log || hashResult.logs, 'error', hashResult && hashResult.hash);
                            props.setTxHashInProgressFalse();
                            clearInterval(time);

                            return;
                        }

                        props.showMessage(variables[props.lang]['check_later']);
                        props.setTxHashInProgressFalse();
                        handleMigration();
                        clearInterval(time);
                    }
                });
            }, 5000);
        }
    };

    const handleMigration = () => {
        const data = {
            channelName: props.username,
            channelDisplayName: props.displayName,
        };
        props.fetchChannelMigration(props.value?._id, data, (cb) => {
            if (cb) {
                props.fetchChannelInfo(props.value?._id);
                if (!cb?.migration) {
                    setMigrationState('error');
                } else {
                    setMigrationState('in_queue');
                    const checkStatus = () => {
                        props.fetchChannelMigrationStatus(props.value?._id, (cb) => {
                            if (cb && !cb.position) {
                                setMigrationState('transfer');
                            }
                            if (cb?.status === 'COMPLETED') {
                                props.fetchChannels(DEFAULT_SKIP, DEFAULT_LIMIT);
                                setMigrationState('success');
                                const channelId = cb?.channel_id;
                                props.router.navigate('/channel/' + channelId);
                                props.fetchChannelVideosStats(channelId);
                                props.fetchChannelContract(props.channelContractAddress?.account_address, props.address, DEFAULT_SKIP, DEFAULT_LIMIT);
                                props.fetchChannelContractInfo(channelId, props.channelContractAddress?.account_address, (res) => {
                                    if (res) {
                                        props.setV2ChannelPresent(true);
                                    }
                                });
                                props.fetchChannelAssets(props.channelContractAddress?.account_address, channelId, DEFAULT_SKIP, DEFAULT_LIMIT);
                                props.fetchChannelContractIV(channelId, DEFAULT_SKIP, DEFAULT_TABLE_LIMIT);
                                clearInterval(time);
                            }
                            if (cb?.status === 'FAILED') {
                                setMigrationState('error');
                                clearInterval(time);
                            }
                        });
                    };

                    checkStatus();
                    const time = setInterval(checkStatus, 2000);
                }
            }
        });
    };

    const handleClose = () => {
        props.handleClose();
        setMigrationState('');
    };

    const handleRetry = () => {
        const data = {};
        props.fetchRetryChannelMigration(props.value?._id, data);
        setMigrationState('in_queue');
        const status = setInterval(() => {
            props.fetchChannelMigrationStatus(props.value?._id, (cb) => {
                if (cb && !cb.position) {
                    setMigrationState('transfer');
                }

                if (cb?.status === 'FAILED') {
                    setMigrationState('error');
                    clearInterval(status);
                }

                if (cb?.status === 'COMPLETED') {
                    props.fetchChannels(DEFAULT_SKIP, DEFAULT_LIMIT);
                    setMigrationState('success');
                    const channelId = cb?.channel_id;
                    props.router.navigate('/channel/' + channelId);
                    props.fetchChannelVideosStats(channelId);
                    props.fetchChannelContract(props.channelContractAddress?.account_address, props.address, DEFAULT_SKIP, DEFAULT_LIMIT);
                    props.fetchChannelContractInfo(channelId, props.channelContractAddress?.account_address, (res) => {
                        if (res) {
                            props.setV2ChannelPresent(true);
                        }
                    });
                    props.fetchChannelAssets(props.channelContractAddress?.account_address, channelId, DEFAULT_SKIP, DEFAULT_LIMIT);
                    props.fetchChannelContractIV(channelId, DEFAULT_SKIP, DEFAULT_TABLE_LIMIT);
                    clearInterval(status);
                }
            });
        }, 5000);
    };

    const handleClick = (value) => {
        if (value !== 'X') { return; }

        const pageUrl = encodeURIComponent(`${appsLinks.TV}/${props.username || props.value?.username}`);
        const newShareText = encodeURIComponent(
            'Migrated my OmniFlix channel to be onchain & fully powered by smart contracts.\n\nI practice what I preach!\n\nDoes your fav creator?\n\nFollow me on OmniFlix TV 👇\n',
        );

        const targetUrl = `https://twitter.com/intent/tweet?text=${newShareText}&url=${pageUrl}`;
        window.open(targetUrl, '_blank');
    };

    const inProgress = props.inProgressTxHash || props.broadCastInProgress || props.channelMigrationInProgress || props.granterInfoInProgress || props.accountInProgress || props.signInProgress;
    const message = props.channelMigrationStatus && getChannelMigrationStatusMessage(props.channelMigrationStatus);
    return (
        <Dialog
            aria-labelledby="migration"
            className="dialog migration_dialog"
            open={props.open}
            onClose={handleClose}>
            <DialogContent className="migration_dialog_content">
                {migrationState === 'success'
                    ? <div className="migration_success">
                        <Lottie animationData={BackgroundWavesAnimation} className="background_waves" loop={true}/>
                        <div>
                            <div className="cancel_icon" onClick={handleClose}>
                                <CancelIcon/>
                            </div>
                            <img alt="SuccessGif" className="success_gif" src={SuccessGif}/>
                            <p>{variables[props.lang]['successfully_migrated_v2']}</p>
                            <span>{variables[props.lang]['migration_success_sub_text']}</span>
                        </div>
                        <Button onClick={() => handleClick('X')}>{variables[props.lang].share_on}{' '}<XIcon className="x_icon"/></Button>
                    </div>
                    : migrationState === 'in_queue'
                        ? <div className="migration_inqueue">
                            <div className="cancel_button" onClick={handleClose}>
                                <CancelIcon/>
                            </div>
                            <p>{variables[props.lang]['migrating_your_channel']}</p>
                            <span>{variables[props.lang]['waiting_for_your_turn']}</span>
                            {props.channelMigrationStatus?.position
                                ? <CircularProgressBar position={props.channelMigrationStatus?.position} progress={progress} type="in_queue"/>
                                : <div className="starting_soon">{variables[props.lang]['starting_soon']}...</div>}
                        </div>
                        : migrationState === 'transfer'
                            ? <div className="migration_transfer">
                                <div className="cancel_button" onClick={handleClose}>
                                    <CancelIcon/>
                                </div>
                                <p>{variables[props.lang]['migrating_your_channel']}</p>
                                <span>{message}</span>
                                <CircularProgressBar progress={progress} type="transfer"/>
                            </div>
                            : migrationState === 'error'
                                ? <div className="migration_success migration_error">
                                    <Lottie animationData={BackgroundWavesAnimation} className="background_waves" loop={true}/>
                                    <div>
                                        <div className="cancel_icon" onClick={handleClose}>
                                            <CancelIcon/>
                                        </div>
                                        <img alt="ErrorGif" className="error_gif" src={ErrorGif}/>
                                        <p>{variables[props.lang]['something_went_wrong']}</p>
                                        <span>{message}{variables[props.lang]['retry_again']}</span>
                                    </div>
                                    <Button disabled={inProgress} onClick={handleRetry}>{variables[props.lang].retry}</Button>
                                </div>
                                : <div className="migration_setup_main">
                                    <div className="cancel_button" onClick={handleClose}>
                                        <CancelIcon/>
                                    </div>
                                    <div className="migration_setup">
                                        <img alt="successIcon" src={successIcon}/>
                                        <div className="migrate_content">
                                            <p>{variables[props.lang]['migrate_without_worry']}</p>
                                            <span>{variables[props.lang]['migrate_without_worry_sub_text']}</span>
                                        </div>
                                        <div className="username_section">
                                            <p>{variables[props.lang].username} <InfoIcon/></p>
                                            <UserNameTextField/>
                                            {!props.inProgress
                                                ? !props.username || props.username.length < 3
                                                    ? <span className="error_text">Min 3 characters required</span>
                                                    : props.status
                                                        ? <span className="error_text">{variables[props.lang]['choose_another_username']}</span>
                                                        : <span>{variables[props.lang]['username_available']}</span>
                                                : null}
                                            <div className="display_name_section">
                                                <p>{variables[props.lang].display_name} <InfoIcon/></p>
                                                <DisplayNameTextField/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="migration_actions">
                                        <Button onClick={handleClose}>{variables[props.lang].cancel}</Button>
                                        {props.channelMigrationStatus?.status === 'FAILED'
                                            ? <Button
                                                disabled={props.status || inProgress}
                                                onClick={handleRetry}>
                                                {variables[props.lang].retry}
                                            </Button>
                                            : <Button
                                                disabled={props.status || inProgress}
                                                onClick={handleGrantValidation}>
                                                {variables[props.lang].continue}
                                            </Button>}
                                    </div>
                                </div>}
            </DialogContent>
        </Dialog>
    );
};

MigrationDialog.propTypes = {
    accountInProgress: PropTypes.bool.isRequired,
    address: PropTypes.string.isRequired,
    allowances: PropTypes.array.isRequired,
    aminoSignTx: PropTypes.func.isRequired,
    authzAccountAddressInProgress: PropTypes.bool.isRequired,
    balance: PropTypes.array.isRequired,
    broadCastInProgress: PropTypes.bool.isRequired,
    channelContractAddress: PropTypes.object.isRequired,
    channelMigrationAuthzAccountAddress: PropTypes.object.isRequired,
    channelMigrationInProgress: PropTypes.bool.isRequired,
    channelMigrationStatus: PropTypes.object.isRequired,
    displayName: PropTypes.string.isRequired,
    fetchBalance: PropTypes.func.isRequired,
    fetchChannelAssets: PropTypes.func.isRequired,
    fetchChannelContract: PropTypes.func.isRequired,
    fetchChannelContractIV: PropTypes.func.isRequired,
    fetchChannelContractInfo: PropTypes.func.isRequired,
    fetchChannelInfo: PropTypes.func.isRequired,
    fetchChannelMigration: PropTypes.func.isRequired,
    fetchChannelMigrationAuthzAccountAddress: PropTypes.func.isRequired,
    fetchChannelMigrationStatus: PropTypes.func.isRequired,
    fetchChannelVideosStats: PropTypes.func.isRequired,
    fetchChannels: PropTypes.func.isRequired,
    fetchGranterInfo: PropTypes.func.isRequired,
    fetchRetryChannelMigration: PropTypes.func.isRequired,
    fetchTxHash: PropTypes.func.isRequired,
    granterInfoInProgress: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    inProgress: PropTypes.bool.isRequired,
    inProgressTxHash: PropTypes.bool.isRequired,
    keys: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    migrationStage: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    setTxHashInProgressFalse: PropTypes.func.isRequired,
    setV2ChannelPresent: PropTypes.func.isRequired,
    showMessage: PropTypes.func.isRequired,
    sign: PropTypes.func.isRequired,
    signInProgress: PropTypes.bool.isRequired,
    status: PropTypes.bool.isRequired,
    txSignAndBroadCast: PropTypes.func.isRequired,
    username: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    router: PropTypes.shape({
        navigate: PropTypes.func.isRequired,
    }),
};

const stateToprops = (state) => {
    return {
        lang: state.language,
        open: state.channels.channelMigration.channelMigrationDialog.open,
        value: state.channels.channelInfo.value,
        username: state.channelContract.channelContractUserName,
        displayName: state.channelContract.channelContractDisplayName,
        balance: state.account.bc.balance.value,
        address: state.account.connection.address,
        allowances: state.account.bc.allowances.value,
        keys: state.account.connection.keys,
        status: state.channelContract.channelContractUsernameStatus,
        inProgress: state.channelContract.channelContractAvailability.inProgress,
        signInProgress: state.account.bc.protoBufSign.inProgress,
        accountInProgress: state.account.connection.inProgress,
        channelMigrationInProgress: state.channels.channelMigration.channelMigration.inProgress,
        granterInfoInProgress: state.interactiveVideos.videoDrops.granterInfo.inProgress,
        broadCastInProgress: state.account.bc.broadCast.inProgress,
        inProgressTxHash: state.account.bc.txHash.inProgress,
        channelMigrationStatus: state.channels.channelMigration.channelMigrationStatus.value,
        channelMigrationAuthzAccountAddress: state.channels.channelMigration.channelMigrationAuthzAccountAddress.value,
        authzAccountAddressInProgress: state.channels.channelMigration.channelMigrationAuthzAccountAddress.inProgress,
        channelContractAddress: state.channelContract.channelContractAddress.value,
        migrationStage: state.channels.channelMigration.channelMigrationDialog.value,
    };
};

const actionToProps = {
    handleClose: hideChannelMigrationDialog,
    fetchChannelMigration,
    sign: protoBufSigning,
    aminoSignTx: aminoSignTxProtoTX,
    showMessage,
    fetchBalance,
    setTxHashInProgressFalse,
    txSignAndBroadCast,
    fetchTxHash,
    fetchGranterInfo,
    fetchChannelMigrationStatus,
    fetchChannelMigrationAuthzAccountAddress,
    fetchChannelContractInfo,
    setV2ChannelPresent,
    fetchChannels,
    fetchChannelAssets,
    fetchChannelContractIV,
    fetchRetryChannelMigration,
    fetchChannelContract,
    fetchChannelInfo,
    fetchChannelVideosStats,
};

export default withRouter(connect(stateToprops, actionToProps)(MigrationDialog));
